import { Ref } from '@/decorators/ref';
import { assignOwnProperties } from '@/utils/assignOwnProperties';
import { normalize } from '@/utils/normalize';
import type { ICrewMember } from '~/api/ICrewMember';
import type { IShiftInfo } from '~/api/IShiftInfo';

export class Shift implements IShiftInfo {
  @Ref id: string;
  @Ref name: string;
  @Ref status: string;
  @Ref vehicleTypeId: string;
  @Ref vehicleId: string;
  @Ref start: string;
  @Ref end: string;
  @Ref duration?: string;
  @Ref unitId?: string;
  @Ref homePostId?: string;
  @Ref startOdometer?: string;
  @Ref crewMembers?: ICrewMember[];

  constructor(data: Partial<IShiftInfo>) {
    assignOwnProperties(this, normalize(data));
  }
}
